import { ref } from 'vue'
import axios from 'axios'
import store from '@/store/index'

export function useSupplierGroups() {
  const loading = ref(false)
  const error = ref(null)
  const groups = ref([])
  const currentGroup = ref(null)

  const apiUrl = store.state.apiUrl

  const fetchGroups = async (siteId) => {
    loading.value = true
    error.value = null
    try {
      const res = await axios.get(`${apiUrl}/groups`, {
        params: { site_id: siteId }
      })
      groups.value = res.data
    } catch (e) {
      error.value = e.response?.data?.detail || e.message
      console.error('[Groups] Fetch error:', e)
    } finally {
      loading.value = false
    }
  }

  const fetchGroup = async (groupId) => {
    loading.value = true
    error.value = null
    try {
      const res = await axios.get(`${apiUrl}/groups/${groupId}`)
      currentGroup.value = res.data
    } catch (e) {
      error.value = e.response?.data?.detail || e.message
      console.error('[Groups] Fetch single error:', e)
    } finally {
      loading.value = false
    }
  }

  const createGroup = async (payload) => {
    loading.value = true
    error.value = null
    try {
      const res = await axios.post(`${apiUrl}/groups`, payload)
      return res.data
    } catch (e) {
      error.value = e.response?.data?.detail || e.message
      console.error('[Groups] Create error:', e)
      throw e
    } finally {
      loading.value = false
    }
  }

  const updateGroup = async (groupId, payload) => {
    loading.value = true
    error.value = null
    try {
      const res = await axios.put(`${apiUrl}/groups/${groupId}`, payload)
      return res.data
    } catch (e) {
      error.value = e.response?.data?.detail || e.message
      console.error('[Groups] Update error:', e)
      throw e
    } finally {
      loading.value = false
    }
  }

  const deleteGroup = async (groupId) => {
    loading.value = true
    error.value = null
    try {
      const res = await axios.delete(`${apiUrl}/groups/${groupId}`)
      return res.data
    } catch (e) {
      error.value = e.response?.data?.detail || e.message
      console.error('[Groups] Delete error:', e)
      throw e
    } finally {
      loading.value = false
    }
  }

  return {
    loading, error, groups, currentGroup,
    fetchGroups, fetchGroup, createGroup, updateGroup, deleteGroup,
  }
}
